module.exports = __webpack_public_path__ + "img/poorter_hotel-124.af076142.jpg";